import { render, staticRenderFns } from "./DownloadButton.vue?vue&type=template&id=05ba2a70"
import script from "./DownloadButton.vue?vue&type=script&lang=js"
export * from "./DownloadButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports